export const applicationActionTypes = {
  setColorTheme: 'set-color-theme',

  setStaticCopy: 'set-static-copy',

  showErrorBanner: 'show-error-banner',
  hideErrorBanner: 'hide-error-banner',
  showSuccessBanner: 'show-success-banner',
  hideSuccessBanner: 'hide-success-banner',

  setCustomClientLogo: 'set-custom-logo',
};

export const advancedSettingsActionTypes = {
  showAdvancedSettings: 'show-adv-settings',
  hideAdvancedSettings: 'hide-adv-settings',
  setAdvancedSettings: 'set-adv-settings',
  setAdvancedSettingsLoading: 'set-adv-settings-loading',
  setAdvancedSettingsLoaded: 'set-adv-settings-loaded',
  setAdvancedSettingsError: 'set-adv-settings-error',
  clearAdvancedSettings: 'clearAdvancedSettings',
};

export const chatHistoryActions = {
  updateResultAnswer: 'update-result-answer',
  updateResultError: 'update-result-error',
  clearChatHistoryData: 'clear-chat-history-data',
};

export const docsActionTypes = {
  addDocs: 'set-docs',
  setMacroDocs: 'set-macro-docs',

  setGettingRecentDocs: 'set-getting-recent-docs',
  setRecentDocs: 'set-recent-docs',

  setGettingRecentFedDocs: 'set-getting-recent-fed-docs',
  setRecentFedDocs: 'set-recent-fed-docs',
};

export const currentUserActionTypes = {
  setCurrentUser: 'set-current-user',
  updateCurrentUser: 'update-current-user',
};

export const gptModelsActionTypes = {
  setLoading: 'gptModels/setLoading',
  set: 'gptModels/set',
  setError: 'gptModels/setError',
};

export const colorThemeActions = {
  set: 'setColorTheme',
  setCustomColorThemeColorDefinition: 'setCustomColorThemeColorDefinition',
  resetCustomColorTheme: 'resetCustomColorTheme',
};
export const fedSentimentActions = {
  setIsGetting: 'set-isGettingFedSentimentResults',
  setResults: 'set-FedSentimentResults',
  setError: 'set-ErrorFedSentimentResults',
  clear: 'clear-FedSentiment',
};
export const flowActions = {
  clear: 'clearFlowState',
};
export const liveDocsActions = {
  addGroups: 'addGroups',
  editDoc: 'editDoc',
  deleteDoc: 'deleteDoc',
};
export const gridTableResultsActions = {
  updateResult: 'updateGridTableResults',
  error: 'errorGridTableResults',
  complete: 'completeGridTableResults',
};
export const gridTableAnalysisActions = {
  replaceFavoriteQuestions: 'replaceFavoriteQuestions',
  addFavoriteQuestion: 'addFavoriteQuestion',
  updateFavoriteQuestion: 'updateFavoriteQuestion',
  removeFavoriteQuestion: 'removeFavoriteQuestion',

  addPrompts: 'addPrompts',
  updatePrompt: 'updatePrompt',
  removePrompt: 'removePrompt',
  replacePrompts: 'replacePrompts',

  initTableRows: 'initTableRows',
  addTableRows: 'addTableRows',
  updateTableRow: 'updateTableRow',
  deleteTableRow: 'deleteTableRow',

  addSelectedDocument: 'addSelectedDocument',
  addSelectedDocuments: 'addSelectedDocuments',
  addSelectedPerColumnDocuments: 'addSelectedPerColumnDocuments',
  removeSelectedDocument: 'removeSelectedDocument',

  loadAllFavs: 'loadAllFavs',

  importTable: 'importTable',
  clearTable: 'clearTable',
};

export const infoIconActions = {
  show: 'showInfoIcon',
  hide: 'hideInfoIcon',
};

export const clientDocsActions = {
  update: 'updateClientDocs',
};

export const watchlistActions = {
  update: 'updateWatchlist',
  add: 'addUpdateWatchlist',
  remove: 'removeWatchlistItem',
};

export const constantsActions = {
  updateDocTypes: 'updateDocTypes',
};

export const tableBuilderActions = {
  addChatHistory: 'addChatHistory',
  clearChatHistory: 'clearChatHistory',
  setCurrentTableJSON: 'setCurrentTableJSON',
  clearCurrentTableJSON: 'clearCurrentTableJSON',
  addCell: 'addCell',
  updateCell: 'updateCell',
  deleteCell: 'deleteCell',
  addRow: 'addRow',
  deleteRow: 'deleteRow',
  deleteRowByIndex: 'deleteRowByIndex',
  insertRowAt: 'insertRowAt',
  addColumn: 'addColumn',
  deleteColumn: 'deleteColumn',
  deleteColumnByIndex: 'deleteColumnByIndex',
  insertColumn: 'insertColumn',
  insertColumnAt: 'insertColumnAt',
  clearTableBuilder: 'clearTableBuilder',
  updateChatError: 'updateChatError',
  updateCurrentResultAnswer: 'updateCurrentResultAnswer',
  setWorkingState: 'setWorkingState',
  updateMetadata: 'updateMetadata',
  setColumnWidth: 'setColumnWidth',
  toggleCellBold: 'toggleCellBold',
  toggleCellItalic: 'toggleCellItalic',
  toggleCellUnderline: 'toggleCellUnderline',
  toggleCellStrike: 'toggleCellStrike',
};

export const uploadStatusActions = {
  receiveData: 'receiveUploadStatusData',
  clearNewlyCompletedUploadDocsCount: 'clearNewlyCompletedUploadDocsCount',
};

export const uploadFilesActions = {
  addFiles: 'addFilesForUpload',
  replaceFile: 'replaceFileForUpload',
  updateFiles: 'updateFilesForUpload',
  deleteFile: 'deleteFileForUpload',
  clear: 'clearFilesForUpload',
};
